import { render, RenderResult } from "@testing-library/react";
import React, { lazy, Suspense } from "react";
import { Navigate, useRoutes, MemoryRouter } from "react-router-dom";

import { paths } from "../paths";
import { authRoutes } from "./auth";
import { dashboardRoutes } from "./dashboard";
import { errorRoutes } from "./error";
import { LoadingScreen } from "src/components/loading-screen";
import RankingWrapper from "src/modules/ranking/components/ranking-wrapper";

// ----------------------------------------------------------------------

export const renderWithRouter = (ui: React.ReactElement): RenderResult =>
  render(
    <MemoryRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      {ui}
    </MemoryRouter>,
  );

export default function Router() {
  return useRoutes([
    // SET INDEX PAGE WITH SKIP HOME PAGE
    {
      path: "/",
      element: <Navigate to={paths.dashboard.home.root} replace />,
    },

    {
      path: "/dashboard/",
      element: <Navigate to={paths.dashboard.home.root} replace />,
    },

    {
      path: "/dashboard/ranking",
      element: (
        <Suspense fallback={<LoadingScreen />}>
          <RankingWrapper />
        </Suspense>
      ),
    },

    ...authRoutes,

    ...errorRoutes,

    ...dashboardRoutes,
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
